import NImage, { ImageProps } from 'next/image';
import React from 'react';

interface Props extends ImageProps {}

export interface NextImageLoader {
  src: string;
  width: number;
  height?: number;
  quality?: number;
}
export const nextImageLoader = ({ src, width, quality }: NextImageLoader) => {
  return `${src}?w=${width}&q=${quality || 75}`;
};

export const NextImage: React.FC<Props> = ({
  loader = nextImageLoader,
  ...props
}) => {
  return <NImage loader={loader} {...props} />;
};
